import { configureStore } from '@reduxjs/toolkit';

//import thunk from 'redux-thunk';
//import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
//import { subscribeActionMiddleware } from 'redux-subscribe-action';
import {
  SidebarReducer,
  LayoutReducer,
  ContentReducer,
  UserReducer,
  DocumentsReducer,
  RouteReducer,
  PreloadedReducer,
  ActionSequencesReducer,
  AIReducer,
  DataLinksReducer,
  LocalReducer,
  StoreReducer
} from '../reducers';

//import subscribe from './../subscribers';

const storeReducers = {
  Sidebar: SidebarReducer,
  Layout: LayoutReducer,
  Content: ContentReducer,
  User: UserReducer,
  Documents: DocumentsReducer,
  Routing: RouteReducer,
  Preloaded: PreloadedReducer,
  AI: AIReducer,
  DataLinks: DataLinksReducer,
  ActionSequences: ActionSequencesReducer,
  Local: LocalReducer,
  Store: StoreReducer
};

const store = configureStore({
  reducer: storeReducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
  devTools: process.env.NODE_ENV !== 'production'
});

/*
const store = createStore(
  combineReducers(storeReducers),
  composeWithDevTools(applyMiddleware(thunk, subscribeActionMiddleware))
);

export const createStoreWithInitialState = initialState => {
  return createStore(combineReducers(storeReducers), initialState);
};
*/

//subscribe();
store.loaded = true;

export default store;
